import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "app/core/auth/auth.service";
import { AuthUtils } from "app/core/auth/auth.utils";
import { EnvConfigService } from "app/env-config.service";
import { Observable, catchError, throwError } from "rxjs";

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);
  const envConfigService = inject(EnvConfigService);

  // Clone the request object
  let newReq = req.clone();
  if (req.url.indexOf("/chats") < 0 && req.url.indexOf("/shortcuts") < 0 && req.url.indexOf("/navigation") < 0 && req.url.indexOf("/messages") < 0 && req.url.indexOf("/notifications") < 0) {
    if (req.url.startsWith("api") || req.url.startsWith("/api")) {
      if (req.url.startsWith("/")) {
        newReq = req.clone({
          url: `${envConfigService.envConfig.APIBASEURL}${req.url}`,
        });
      } else {
        newReq = req.clone({
          url: `${envConfigService.envConfig.APIBASEURL}/${req.url}`,
        });
      }
    }
  }

  // Request
  //
  // If the access token didn't expire, add the Authorization header.
  // We won't add the Authorization header if the access token expired.
  // This will force the server to return a "401 Unauthorized" response
  // for the protected API routes which our response interceptor will
  // catch and delete the access token from the local storage while logging
  // the user out from the app.
  if (authService.accessToken) {
    newReq = newReq.clone({
      headers: req.headers.set("X-Auth-Token", authService.accessToken),
    });
  }

  // Response
  return next(newReq).pipe(
    catchError((error) => {
      // Catch "401 Unauthorized" responses
      if (error instanceof HttpErrorResponse && error.status === 401) {
        // Sign out
        if (!newReq.headers.get("Skip-Ui-401")) {
          authService.signOut();

          // Reload the app
          location.reload();
        }
      }

      return throwError(error);
    })
  );
};
